import React from 'react'
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerHeader,
  Divider,
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import type { FileDetailsResponse } from '../../../interfaces/FileDetailsResponse'
import AuditLogs from '../Details/AuditLogs'

const FileHistoryDrawer = ({
  isOpen,
  onClose,
  fileDetails,
}: {
  isOpen: boolean
  onClose(): void
  fileDetails: FileDetailsResponse
}): React.ReactElement => {
  const { t } = useTranslation('t')

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="right" size="sm">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>{t('history', 'History')}</DrawerHeader>
        <Divider />
        <DrawerBody padding={0} height="100%">
          <AuditLogs
            entityId={fileDetails.fileId}
            entityDetails={fileDetails}
          />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

export default FileHistoryDrawer
